import "../App.css";

export default function PromptCounter({ numPrompts }) {
  const className = numPrompts < 100 ? "countdown-l" : "countdown-m";

  return <div className={className}>{numPrompts}</div>;
}
